import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import useCommonMixin from '@/composables/useCommonMixin'
  import UsersApi from '@/services/api/UsersApi'
  import useSegment from '@/composables/useSegment'
  import useCourse from '@/composables/useCourse'
  import eventBus from '@/main'
  import useI18n from '@/composables/useI18n'
  import type { PropType } from 'vue'
  import type { ExamDateDetails } from '@/services/interfaces/Course'
  import { UserModule } from '@/store/modules/user'
  import { CourseModule } from '@/store/modules/course'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseExamDate',
  props: {
    examDateDetails: {
      type: Object as PropType<ExamDateDetails>,
      required: true,
    },
  },
  setup(__props) {

const props = __props;

  
  const { translateString } = useI18n()
  const {
    formatDate,
    daysDifferenceFromNow,
    downloadItem,
    identifyUserInSegmentWithExamDates,
    showExamAppointmentModal,
    setSkipSettingExamAppointment,
    closeModal,
  } = useCommonMixin()
  const { examAppointmentRemoved } = useSegment()
  const { course } = useCourse()

  const realExamDate = computed(() => props.examDateDetails?.realExamDate)

  const daysLeftTillTheExam = computed(() => (examDate: string | null) => {
    return examDate ? daysDifferenceFromNow(examDate, true) : 0
  })

  const daysLeftTillTheExamText = computed(() => (examDate: string) => {
    const daysLeft = daysLeftTillTheExam.value(examDate)

    if (daysLeft > 0 && daysLeft < 1) {
      return translateString('examDatePicker.lessThanOneDayLeft', {
        date: formatDate(examDate, 'dd.MM.yyyy'),
      })
    } else if (daysLeft < 0) {
      return translateString('examDatePicker.examDateHasPassed', {
        date: formatDate(examDate, 'dd.MM.yyyy'),
      })
    }

    return translateString('examDatePicker.daysLeftTillTheExam', {
      days: Math.floor(daysLeft),
      date: formatDate(examDate, 'dd.MM.yyyy'),
    })
  })

  const downloadTipsDocument = () => {
    if (props.examDateDetails.examTipsDownloadUrl) {
      downloadItem(props.examDateDetails.examTipsDownloadUrl)
    }
  }

  const triggerRemoveDate = () => {
    UsersApi.cancelExamAppointment(course.value!.id)
      .then(() => {
        CourseModule.setCourseRealExamDate(null)
        UserModule.getUser()
        setSkipSettingExamAppointment(true)
        identifyUserInSegmentWithExamDates(course.value!.shortTitle, null)
        examAppointmentRemoved(course.value!.id, course.value!.title)
      })
      .finally(() => {
        closeModal()
      })
  }

  const removeExamDate = () => {
    eventBus.$emit('show-modal', {
      modalContentComponent: 'ConfirmationModal',
      modalTitle: translateString('examDatePicker.examDateRemoval'),
      modalProps: {
        confirmationText: translateString('examDatePicker.examDateRemovalConfirmationText'),
        okCallback: triggerRemoveDate,
        cancelButtonText: translateString('cancel'),
      },
      cssClass: 'confirmation',
      modalCloseCallback: (callback: () => void) => {
        if (typeof callback === 'function') callback()
      },
    })
  }

  const triggerAppointmentModal = () => {
    showExamAppointmentModal(course.value!.id)
  }

return { __sfc: true,props, translateString, formatDate, daysDifferenceFromNow, downloadItem, identifyUserInSegmentWithExamDates, showExamAppointmentModal, setSkipSettingExamAppointment, closeModal, examAppointmentRemoved, course, realExamDate, daysLeftTillTheExam, daysLeftTillTheExamText, downloadTipsDocument, triggerRemoveDate, removeExamDate, triggerAppointmentModal, computed, useCommonMixin, UsersApi, useSegment, useCourse, eventBus, useI18n, UserModule, CourseModule }
}

})